/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [navigation-more-less.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 22.02.20, 14:19
 */

import React from 'react';

import {TooltipButton} from "../navigation/buttons/nav-buttons";
import {useLanguage} from "../configuration/configuration";
import {AddBoxOutlined} from "@material-ui/icons";
import {SquareMinusIcon} from "../navigation/icons/nav-icons";
import {cn} from "../util/text-utils";

const NavigationMoreLess = ({className, callback, open, ...otherProps}) => {
    const Lang = useLanguage();

    const title = open ? Lang.tooltip.lessContent : Lang.tooltip.moreContent;
    const text = open ? Lang.button.readLess : Lang.button.readMore;

    return <TooltipButton title={title} className={cn('btn navigation-more-less', [className])}
                     onClick={callback}
                     {...otherProps}>
        <div className='box-aligned'>
            {open ? <SquareMinusIcon className='mr-1 px-1'/> : <AddBoxOutlined fontSize='small' className='mr-1'/>}
            {text}
        </div>

    </TooltipButton>
};

export default NavigationMoreLess;